<template>
    <p class='arrow' ref='arrow'>
       &#x27a4; 
    </p>
</template>
<script>

export default {
    name:"Arrow",
    props:['angle'],
    mounted(){
        this.$refs.arrow.style.transform=`rotate(${90+this.angle}deg) scaleX(2)`
        this.$refs.arrow.style.color='red'
        console.log(this.$refs.arrow);

    },
    updated(){
        this.$refs.arrow.style.transform=`rotate(${90+this.angle}deg) scaleX(2)`
        this.$refs.arrow.style.color='red'
        console.log(this.$refs.arrow);
    }
}
</script>